import { Injectable } from '@angular/core';
import moment from 'moment';
import { BusinessService } from './business.service';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LocalBackupService {

  constructor(
    private businessService: BusinessService,
  ) { }

  async getBackup(name: string) {
    const backup = localStorage.getItem(await this.getStorageName(name));
    if (!backup) 
      return null;
    return this.unserializeObjects(JSON.parse(backup));
  }

  async setBackup(name: string, data: any) {
    localStorage.setItem(await this.getStorageName(name), JSON.stringify(await this.serializeObjects(data)));
  }

  async clearBackup(name: string) {
    localStorage.removeItem(await this.getStorageName(name));
  }

  private async getStorageName(name: string) {
    const businessId = (await this.businessService.selectedBusiness$.pipe(take(1)).toPromise())!.businessId ;
    return `${businessId}/${name}`;
  }

  private async serializeObjects(obj: any): Promise<any> {
    if (obj instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(obj);
      return new Promise((resolve) => {
        reader.onload = () => resolve(`filename:${obj.name},${reader.result}` as string);
      });
    }

    if (!obj || typeof obj !== 'object' || obj instanceof Date)
      return obj;

    if (Array.isArray(obj))
      return Promise.all(obj.map(i => this.serializeObjects(i)));

    const res: any = {};
    for (const key in obj) {
      const value = (obj as any)[key];
      res[key] = await this.serializeObjects(value);
    }
    return res;
  }

  private async unserializeObjects(obj: any): Promise<any> {
    if (typeof obj === 'string' && obj.startsWith('filename:')) {
      let [filename, type, base64String] = obj.split(',');
      type = type.split(':')[1].split(';')[0];
      filename = filename.split(':')[1];
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray]);
      const file = new File([blob], filename, { type });
      return file;
    }

    if (typeof obj === 'string' && isNaN(+obj) && moment(obj, moment.ISO_8601, true).isValid())
      return new Date(obj);

    if (!obj || typeof obj !== 'object')
      return obj;

    if (Array.isArray(obj))
      return Promise.all(obj.map(i => this.unserializeObjects(i)));

      const res: any = {};
    for (const key in obj) {
      const value = (obj as any)[key];
      res[key] = await this.unserializeObjects(value);
    }
    return res;
  }

}
